// extracted by mini-css-extract-plugin
module.exports = {"days":"Days-days","selected":"Days-selected","today":"Days-today"};